module.exports = "//static.hsappstatic.net/conversations-internal-components/static-1.4266/img/preview-tablet.svg"


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/conversations-visitor/node_modules/bender-webpack/lib/bender-url-loader.js!/usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/img/preview-tablet.svg
// module id = 839
// module chunks = 2 3